<div class="dropdown d-inline-block btn-location" ngbDropdown *ngIf="location?.id">
  <button ngbDropdownToggle id="dropdown-locations" type="button" class="btn header-item waves-effect">
    <div class="d-xl-inline-block font-bold height-xs pt-md-2">
      <span class="noti-icon">
        <i class="bx bx-map icon-map"></i>
      </span>
      <span>{{ location.companyName }}</span>
      <i class="mdi mdi-chevron-down"></i>
    </div>
  </button>

  <div class="dropdown-menu p-0" aria-labelledby="dropdown-locations" ngbDropdownMenu>
    <lib-filter-select *ngIf="locationsList?.length" [formControl]="locationControl" [items]="locationsList"> </lib-filter-select>
  </div>
</div>

<div class="dropdown d-inline-block btn-cash-register" ngbDropdown *ngIf="cashRegister?.id">
  <button ngbDropdownToggle id="dropdown-cash-registers" type="button" class="btn header-item waves-effect">
    <div class="d-xl-inline-block font-bold height-xs pt-md-2">
      <span class="noti-icon">
        <i class="bx bx-desktop icon-desktop"></i>
      </span>
      <span>{{ cashRegister.name }} </span>
      <i class="mdi mdi-chevron-down"></i>
    </div>
  </button>

  <div class="dropdown-menu p-0" aria-labelledby="dropdown-cash-register" ngbDropdownMenu>
    <lib-filter-select [formControl]="cashRegisterControl" [items]="cashRegistersList"> </lib-filter-select>
  </div>
</div>
